import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Styles from "./Components.module.scss";
import callIcon from "../../../assets/callIcon.svg";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#000000",
    padding: "0",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={`${classes.closeButton} ${Styles.closeButton}`}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: "0 32px 43px 32px",
    borderBottom: "unset",
    textAlign: "center",
    color: "#757575",
    fontSize: "16px"
  },
}))(MuiDialogContent);

export default function CallInitiatedModal(props) {
  const {
    openConfirmationDialog,
    setOpenConfirmationDialog,
    title,
    content,
  } = props;

  const handleClose = () => {
    setOpenConfirmationDialog({ id: "", flag: false });
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={openConfirmationDialog.id === "initiated" && openConfirmationDialog.flag}
      classes={{ paper: Styles.callInitiatedModalPaper }}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <div className={Styles.boxTitle}>
          <img src={callIcon} alt="call" />
          {title}
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom>{content}</Typography>
      </DialogContent>
    </Dialog>
  );
}
